import { Dispatch } from 'react';
import api from '~/services';
import { AgentStatusPayload } from '~/services/types';
import { log } from '~/helpers';
import * as actionTypes from './actionTypes';
import { DynamicQueueList, DynamicQueue } from '../reducers/dynamicQueues';

type DynamicQueueStoreAction = {
  type: string;
  payload: DynamicQueueList;
};

/**
 * This function includes a isLogged flag which indicate is the account extension is login or not
 */
const addExtensionStatus = (
  dynamicQueueList: DynamicQueueList,
  extStatus: string[]
) =>
  dynamicQueueList.map(dynamicQueueInfo => {
    return {
      ...dynamicQueueInfo,
      isLogged: extStatus.includes(dynamicQueueInfo.queue.name) || false,
    };
  });

/**
 * Fetch the status to an account and extesion in order to validate if it is loggged or not
 */
export const fetchAgentQueueStatus = (queueList: DynamicQueueList) => async (
  dispatch: Dispatch<DynamicQueueStoreAction>
) => {
  const [{ extensionNumber, accountId }] = queueList;

  const { queues: extStatus } = (
    await api.queues.get.dynamicQueueStatus(accountId, extensionNumber)
  ).data;

  if (queueList) {
    const queueListWithStatus = addExtensionStatus(queueList, extStatus);

    dispatch({
      type: actionTypes.DYNAMIC_QUEUES_STORE,
      payload: queueListWithStatus,
    });
  }
};

/**
 * Fetch queues an extension belong to
 */
export const fetchAgentQueues = () => async (dispatch: Dispatch<any>) => {
  try {
    // Fetch queue the account extension is into only
    const queueList: DynamicQueueList = (await api.queues.get.dynamicQueues())
      ?.data;

    if (queueList?.length) {
      dispatch(fetchAgentQueueStatus(queueList));
    }
  } catch (err) {
    log.error('Error to fetch dynamic extensions in queues:', err);
  }
};

export const enterQueue = (queueInfo: DynamicQueue) => async (
  dispatch: Dispatch<any>
) => {
  try {
    const { extensionNumber, queue } = queueInfo;

    await api.queues.post.setAgentStatus({
      queue: queue.number,
      extension: extensionNumber,
      action: 'login',
      platform: 2,
    } as AgentStatusPayload);

    dispatch(fetchAgentQueues());
  } catch (err) {
    log.error('Error to enter extension into the queue:', err);
  }
};

export const exitQueue = (dynamicQueueInfo: DynamicQueue) => async (
  dispatch: Dispatch<any>
) => {
  try {
    const { extensionNumber, queue } = dynamicQueueInfo;

    await api.queues.post.setAgentStatus({
      queue: queue.number,
      extension: extensionNumber,
      action: 'logoff',
      platform: 2,
    } as AgentStatusPayload);

    dispatch(fetchAgentQueues());
  } catch (err) {
    log.error('Error to exit extension from the queue:', err);
  }
};

export const resetDynamicQueues = () => async (dispatch: Dispatch<any>) => {
  dispatch({
    type: actionTypes.RESET_DYNAMIC_QUEUES,
  });
};
